import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { AuditTrailService } from './../../../services/audit-trail.service';
import { UserMasterService } from './../../../services/user-master.service';
import { LayoutService } from './../../../services/layout.service';
import { forkJoin, Subject, Subscription } from 'rxjs';

import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import * as _ from 'lodash';
import { DataTableDirective } from 'angular-datatables';

declare var $: any;
declare var jQuery: any;
declare var autosize: any;

@Component({
  selector: 'app-audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.css'],
})
export class AuditComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(DataTableDirective, { static: true })
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  private sidebarSubscription: Subscription;
  private resizeListener: any;

  public userList: any;
  public actionType: any = ["Login","All","UPSI"];
  public companyList: any;
  public DateRangeFromModel: any;
  public DateRangeToModel: any;
  public DateRangeFrom: any;
  public DateRangeTo: any;
  public auditTrailFilter: FormGroup;
  public databaseBackupForm: FormGroup;
  public autoBackupForm: FormGroup;
  public loglist: any;
  public errorValue: boolean;
  public path: string;
  public backupSchedulerFrequencyList: any;
  selectedValue: any;

  // dtOptions: DataTables.Settings = {};
  // dtTrigger: Subject<any> = new Subject();

  constructor(
    private auditTrailService: AuditTrailService,
    private userMasterService: UserMasterService,
    private fb: FormBuilder,
    private layoutService: LayoutService
  ) {}

  ngOnInit() {
    this.errorValue = false;
    const self = this; // Store reference to component instance
    this.dtOptions = {
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      stateSave: true,
      stateDuration: -1,
      pageLength: 10,
      search: true,
      dom: 'lBfrtip',
      processing: false,
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          title: 'Audit Trail List',
          extend: 'excel',
          exportOptions: {
            columns:[0,1,2,3,4,5,6,7,8,9,10],
            format: {
              body: function(data: any, row: number, column: number, node: any) {
                // Get the original row data from loglist
                const rowData = self.loglist[row];
                if (!rowData) return data;
                
                // Helper to pick unmasked email
                const pickEmail = (obj, keys: string[]) => {
                  for (const k of keys) {
                    if (obj && obj[k]) return obj[k];
                  }
                  return data;
                };
                
                // Column 3 is "Created By" (emailId) - return unmasked email
                if (column === 3) {
                  return pickEmail(rowData, ['emailIdOriginal', 'emailIdUnmasked', 'emailId']);
                }
                
                // Column 8 is "Approved By" (approvedByEmailId) - return unmasked email
                if (column === 8) {
                  return pickEmail(rowData, ['approvedByEmailIdOriginal', 'approvedByEmailIdUnmasked', 'approvedByEmailId']);
                }
                
                // For other columns, return data as is
                return data;
              },
            },
          },
        },
        {
          text: '<i class="fa fa-file-pdf-o"></i>Export to PDF',
          className: 'btn btn-sm btn-warning export-btn',
          title: 'Audit Trail List',
          extend: 'pdfHtml5',
          orientation: 'landscape',
          pageSize: 'A4',
          exportOptions: {
            columns: [0,1,2,3,4,5,6,7,8,9,10],
            format: {
              body: function(data: any, row: number, column: number, node: any) {
                // Get the original row data from loglist
                const rowData = self.loglist[row];
                if (!rowData) return data;
                
                const pickEmail = (obj, keys: string[]) => {
                  for (const k of keys) {
                    if (obj && obj[k]) return obj[k];
                  }
                  return data;
                };
                
                // Column 3 is "Created By" (emailId) - return unmasked email
                if (column === 3) {
                  return pickEmail(rowData, ['emailIdOriginal', 'emailIdUnmasked', 'emailId']);
                }
                
                // Column 8 is "Approved By" (approvedByEmailId) - return unmasked email
                if (column === 8) {
                  return pickEmail(rowData, ['approvedByEmailIdOriginal', 'approvedByEmailIdUnmasked', 'approvedByEmailId']);
                }
                
                // For other columns, return data as is
                return data;
              },
            },
          },
          action: function (e, dt, node, config) {
            try {
              if (typeof $.fn.dataTable.ext.buttons.pdfHtml5 !== 'undefined') {
                $.fn.dataTable.ext.buttons.pdfHtml5.action.call(this, e, dt, node, config);
              } else {
                alert('PDF export is not available. Please ensure pdfmake library is loaded.');
              }
            } catch (error) {
              console.error('PDF export error:', error);
              alert('An error occurred while exporting to PDF. Please try again.');
            }
          },
        },
      ],
      language: {
        //made changes for datatables for next previous button
        paginate: {
          first: '<<',
          last: '>>',
          next: '>',
          previous: '<',
        },
      },
      lengthMenu: [
        [5, 10, 25, 50, 100, -1],
        [5, 10, 25, 50, 100, 'All'],
      ],
      scrollX: true,
      drawCallback: function() {
        // Remove blank row below header on every draw
        const table = $('#logtable');
        if (table.length) {
          // Remove processing row
          table.find('tbody tr.processing').remove();
          
          // Remove first row if it's empty
          const firstRow = table.find('tbody tr:first-child');
          if (firstRow.length) {
            let isEmpty = true;
            firstRow.find('td').each(function() {
              const cellText = $(this).text().trim();
              const cellHtml = $(this).html().trim();
              if (cellText !== '' && 
                  cellText !== 'No data available in table' && 
                  cellHtml !== '' && 
                  cellHtml !== '&nbsp;' && 
                  cellHtml !== '<br>' && 
                  cellHtml !== '<br/>') {
                isEmpty = false;
                return false;
              }
            });
            if (isEmpty) {
              firstRow.remove();
            }
          }
          
          // Adjust columns to fix header/body alignment
          const dataTable = table.DataTable();
          if (dataTable) {
            // Use DataTables built-in column adjustment - this handles scrollX alignment
            dataTable.columns.adjust();
            
            // Additional sync after DataTables has adjusted
            setTimeout(() => {
              // Get the actual body table (the one in scrollBody)
              const bodyTable = $('#logtable_wrapper .dataTables_scrollBody table');
              const headerTable = $('#logtable_wrapper .dataTables_scrollHeadInner table');
              
              if (bodyTable.length && headerTable.length) {
                // Get all body cells from first row to measure widths
                const firstBodyRow = bodyTable.find('tbody tr:first-child');
                const headerCols = headerTable.find('thead th');
                
                if (firstBodyRow.length > 0 && headerCols.length > 0) {
                  // Measure each column from body and apply to header
                  firstBodyRow.find('td').each(function(index) {
                    const $bodyCell = $(this);
                    const $headerCell = headerCols.eq(index);
                    
                    if ($headerCell.length) {
                      // Get computed width including padding and borders
                      const bodyWidth = $bodyCell[0].getBoundingClientRect().width;
                      
                      if (bodyWidth > 0) {
                        // Apply width to header cell
                        $headerCell.css({
                          'width': bodyWidth + 'px',
                          'min-width': bodyWidth + 'px',
                          'max-width': bodyWidth + 'px',
                          'box-sizing': 'border-box'
                        });
                        
                        // Apply to all body cells in this column
                        bodyTable.find('tbody tr').each(function() {
                          const $cell = $(this).find('td').eq(index);
                          if ($cell.length) {
                            $cell.css({
                              'width': bodyWidth + 'px',
                              'min-width': bodyWidth + 'px',
                              'max-width': bodyWidth + 'px',
                              'box-sizing': 'border-box'
                            });
                          }
                        });
                      }
                    }
                  });
                  
                  // Sync colgroup if exists
                  const bodyColgroup = bodyTable.find('colgroup');
                  const headerColgroup = headerTable.find('colgroup');
                  
                  if (bodyColgroup.length && headerColgroup.length) {
                    bodyColgroup.find('col').each(function(index) {
                      const $bodyCol = $(this);
                      const $headerCol = headerColgroup.find('col').eq(index);
                      if ($headerCol.length) {
                        const width = $bodyCol.width();
                        if (width > 0) {
                          $headerCol.css('width', width + 'px');
                        }
                      }
                    });
                  }
                }
              }
            }, 200);
          }
        }
      },
      initComplete: function() {
        // Remove blank row below header
        const table = $('#logtable');
        if (table.length) {
          // Remove processing row
          table.find('tbody tr.processing').remove();
          
          // Remove first row if it's empty
          const firstRow = table.find('tbody tr:first-child');
          if (firstRow.length) {
            let isEmpty = true;
            firstRow.find('td').each(function() {
              const cellText = $(this).text().trim();
              const cellHtml = $(this).html().trim();
              if (cellText !== '' && 
                  cellText !== 'No data available in table' && 
                  cellHtml !== '' && 
                  cellHtml !== '&nbsp;' && 
                  cellHtml !== '<br>' && 
                  cellHtml !== '<br/>') {
                isEmpty = false;
                return false;
              }
            });
            if (isEmpty) {
              firstRow.remove();
            }
          }
          
          // Remove any empty rows
          table.find('tbody tr').each(function() {
            const $row = $(this);
            let hasContent = false;
            $row.find('td').each(function() {
              const $cell = $(this);
              const text = $cell.text().trim();
              const html = $cell.html().trim();
              if (text !== '' && 
                  text !== 'No data available in table' && 
                  html !== '' && 
                  html !== '&nbsp;' && 
                  html !== '<br>' && 
                  html !== '<br/>' &&
                  !$cell.hasClass('dataTables_empty')) {
                hasContent = true;
                return false;
              }
            });
            if (!hasContent && $row.find('td').length > 0) {
              $row.remove();
            }
          });
        }
        
        // Adjust columns after initialization
        setTimeout(() => {
          const table = $('#logtable');
          if (table.length) {
            const dataTable = table.DataTable();
            if (dataTable) {
              dataTable.columns.adjust().draw(false);
            }
          }
        }, 100);
        
        // Restructure toolbar to single line after initialization
        setTimeout(() => {
          const wrapper = $('#logtable_wrapper');
          if (wrapper.length) {
            let firstRow = wrapper.children('.row').first();
            if (!firstRow.length) {
              // Try alternative selector
              firstRow = wrapper.find('.row').first();
            }
            
            if (firstRow.length) {
              // Force flex layout
              firstRow.css({
                'display': 'flex !important',
                'flex-wrap': 'nowrap !important',
                'align-items': 'center !important',
                'justify-content': 'flex-start !important',
                'margin': '0 !important',
                'padding': '10px 0 !important',
                'width': '100% !important'
              });
              
            // Make all child divs inline, but don't set margin-left on filter column yet
            firstRow.find('> div').each(function() {
              const $div = $(this);
              const hasFilter = $div.find('.dataTables_filter').length > 0;
              
              if (!hasFilter) {
                // Only style non-filter columns
                $div.css({
                  'display': 'inline-flex !important',
                  'align-items': 'center !important',
                  'flex': '0 0 auto !important',
                  'width': 'auto !important',
                  'max-width': 'none !important',
                  'float': 'none !important',
                  'padding-right': '15px !important',
                  'padding-left': '0 !important',
                  'margin': '0 !important',
                  'margin-left': '0 !important'
                });
              }
            });

              // Push search filter to the right
              const filterCol = firstRow.find('[class*="col-"]:has(.dataTables_filter)');
              if (filterCol.length) {
                filterCol.css({
                  'margin-left': 'auto !important',
                  'flex': '0 0 auto !important',
                  'width': 'auto !important'
                });
              } else {
                // Fallback: push last column to the right
                const lastCol = firstRow.children().last();
                if (lastCol.length && lastCol.find('.dataTables_filter').length) {
                  lastCol.css({
                    'margin-left': 'auto !important',
                    'flex': '0 0 auto !important',
                    'width': 'auto !important'
                  });
                }
              }
              
              // Ensure length, buttons, and filter are inline
              firstRow.find('.dataTables_length').css({
                'float': 'none !important',
                'display': 'inline-flex !important',
                'margin': '0 !important'
              });
              
              firstRow.find('.dt-buttons').css({
                'float': 'none !important',
                'display': 'inline-flex !important',
                'margin': '0 15px 0 0 !important'
              });
              
              // Ensure filter is pushed to right
              const filter = firstRow.find('.dataTables_filter');
              if (filter.length) {
                // Find the parent column that contains the filter
                let filterParent = filter.closest('[class*="col-"]');
                
                // If no col- parent found, try parent div
                if (!filterParent.length) {
                  filterParent = filter.parent();
                }
                
                if (filterParent.length) {
                  // Make the parent column push to right
                  filterParent.css({
                    'margin-left': 'auto !important',
                    'margin-right': '0 !important',
                    'flex': '0 0 auto !important',
                    'width': 'auto !important',
                    'float': 'none !important',
                    'display': 'flex !important',
                    'justify-content': 'flex-end !important'
                  });
                }
                
                // Also style the filter itself to ensure it's right-aligned
                filter.css({
                  'margin-left': 'auto !important',
                  'margin-right': '0 !important',
                  'float': 'none !important',
                  'display': 'inline-flex !important'
                });
              }
              
              // Alternative: Find all columns and make the one containing filter push right
              firstRow.children('[class*="col-"]').each(function() {
                const $col = $(this);
                if ($col.find('.dataTables_filter').length) {
                  $col.css({
                    'margin-left': 'auto !important',
                    'margin-right': '0 !important',
                    'flex': '0 0 auto !important',
                    'width': 'auto !important',
                    'float': 'none !important',
                    'display': 'flex !important',
                    'justify-content': 'flex-end !important'
                  });
                }
              });
              
              // Also try finding the filter's parent at any level and push it right
              if (filter.length) {
                const filterParent = filter.parents('div').first();
                if (filterParent.length && !filterParent.hasClass('row') && filterParent.find('.dataTables_filter').length) {
                  filterParent.css({
                    'margin-left': 'auto !important',
                    'flex': '0 0 auto !important',
                    'width': 'auto !important',
                    'display': 'flex !important',
                    'justify-content': 'flex-end !important'
                  });
                }
              }
            }
          }
        }, 100);
      }
    };

    this.backupSchedulerFrequencyList = [
      { label: 'Hourly', value: 'Hourly' },
      { label: 'Daily', value: 'Daily' },
    ];

    this.autoBackupForm = new FormGroup({
      autoBackupFrequency: new FormControl('', [Validators.required]),
      autoBackupServerName: new FormControl('', [Validators.required]),
      autoBackupPassword: new FormControl('', [Validators.required]),
      autoBackupLocation: new FormControl('', [Validators.required]),
      autoBackupServerUserName: new FormControl('', [Validators.required]),
    });

    //console.log('inside ngOninit')
    this.auditTrailFilter = new FormGroup({
      username: new FormControl('', []),
      companyName: new FormControl('', []),
      DateRangeFrom: new FormControl('', [Validators.required]),
      DateRangeTo: new FormControl('', [Validators.required]),
      actionType: new FormControl('',[Validators.required])
    });

    this.databaseBackupForm = this.fb.group({
      serverName: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
      location: new FormControl('', [Validators.required]),
      serverUserName: new FormControl('', [Validators.required]),
    });

    let promiseArray = [];
    // promiseArray.push(this.userMasterService.getUserList())
    // promiseArray.push(this.auditTrailService.getCollectionNameList())
    // this.path = '/home/ec2-user/db_backup/'
    forkJoin([
      this.userMasterService.getUserList(),
      this.auditTrailService.getCompanyNameList(),
      this.auditTrailService.getauditTrailLogs(),
      this.auditTrailService.getDatabaseBackupLocation(),
    ]).subscribe((reposnse) => {
      if (_.size(reposnse[3].result)) {
        let dbLocationObject = _.first(reposnse[3].result);
        this.path = _.get(dbLocationObject, 'path');
      } else {
        this.path = '';
      }
      reposnse[0].result.push(0, { Title: '', FirstName: 'All', LastName: '' });
      reposnse[0].result = _.filter(reposnse[0].result, function (element) {
        return element.Title != null;
      });
      this.userList = _.map(reposnse[0].result, function (userInformation) {
        return {
          label:
            _.get(userInformation, 'Title') +
            ' ' +
            _.get(userInformation, 'FirstName') +
            ' ' +
            _.get(userInformation, 'LastName'),
          value: _.get(userInformation, '_id'),
        };
      });
      // this.userList = []
      this.userList.reverse();
      reposnse[1].collectionList.push({ label: 'All', value: null });
      this.companyList = reposnse[1].collectionList;
      this.companyList.reverse();
      // //console.log('reposnse[2].loggerList', reposnse[2].loggerList)
      // for(let index = 0; index < reposnse[2].loggerList.length; index++) {
      //   reposnse[2].loggerList[index].Data = reposnse[2].loggerList[index].Data
      //   // //console.log('reposnse[2].loggerList[index].Data', reposnse[2].loggerList[index].Data)
      // }
      if (!reposnse[2].status) {
        this.loglist = reposnse[2].loggerList;
      } else {
        this.loglist = [];
        this.errorValue = true;
      }
      this.dtTrigger.next();
    });
  }

  getInputValueChange(event: Event): string {
    // @ts-ignore
    return (event.target ? (event.target as HTMLInputElement) : event).value;
  }

  takeDatabaseBackUp() {
    const serverDetails = {
      serverName: this.databaseBackupForm.controls['serverName'].value,
      serverPath: this.databaseBackupForm.controls['location'].value,
      serverPassword: this.databaseBackupForm.controls['password'].value,
      serverUserName: this.databaseBackupForm.controls['serverUserName'].value,
    };
    this.auditTrailService
      .takeDatabaseBackup(serverDetails)
      .then((response) => {
        //console.log('response take back up', response)
        if (!response.status) {
          this.databaseBackupForm.reset();
          this.path = _.get(response.result, 'path');
          $('#alertTitle').text('Success!');
          $('#alertTitle').css('color', 'black');
          $('#alertMessage').text('Backup has been taken!');
          $('#alertMessage').css('color', 'black');
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
        } else {
          $('#alertTitle').css('color', '#f00');
          $('#alertTitle').text('Failure!');
          $('#alertMessage').text(response.message);
          $('#alertMessage').css('color', '#f00');
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
        }
      });
  }

  setAutoBackupScheduler() {
    const setParameters = {
      companyId: JSON.parse(localStorage.getItem('user')).CompanyId,
      BackupScheduleFrequency:
        this.autoBackupForm.controls['autoBackupFrequency'].value,
      serverName: this.autoBackupForm.controls['autoBackupServerName'].value,
      serverPath: this.autoBackupForm.controls['autoBackupLocation'].value,
      serverPassword: this.autoBackupForm.controls['autoBackupPassword'].value,
      serverUserName:
        this.autoBackupForm.controls['autoBackupServerUserName'].value,
    };

    //console.log("auto backup form", this.autoBackupForm.controls['autoBackupFrequency'].value);

    this.auditTrailService
      .setAutoBackupScheduler(setParameters)
      .then(
        (response) => {
          //console.log("response");
        },
        (error) => console.log('')
      )
      .catch();
  }

  filterLog() {
    const {username, companyName, actionType} = this.auditTrailFilter.value
    let filterObject = {
      userName: username ? username.value : null,
      actionType: actionType ? actionType : null,
      companyId: companyName ? companyName.value : null,
      DateRangeFrom: new Date(
        this.setDate(this.auditTrailFilter.controls['DateRangeFrom'].value)
      ),
      DateRangeTo: new Date(
        this.setDate(this.auditTrailFilter.controls['DateRangeTo'].value)
      ),
    };

    this.loglist = [];
    $('#logtable').DataTable().destroy();
    this.auditTrailService.getFilterLogs(filterObject).then((response) => {
      //console.log('response for the filterlog', response)
      if (!response.status) {
        this.errorValue = false;
        if (_.size(this.loglist)) {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
          });
        }

        this.loglist = response.filterLogList;
        this.dtTrigger.next();
      } else {
        this.errorValue = true;
        this.loglist = [];
      }
    });
  }

  clearFilter() {
    this.auditTrailFilter.reset();
    // this.ngOnInit();
    var filterObjects = { filter: null };
    this.loglist = [];
    //console.log('filterObject', filterObjects)
    $('#logtable').DataTable().destroy();
    this.auditTrailService.getFilterLogs({}).then((response) => {
      //console.log('response for the filterlog', response)
      if (!response.status) {
        this.errorValue = false;

        if (_.size(this.loglist)) {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy(); 
          });
        }

        this.loglist = response.filterLogList;
        this.dtTrigger.next();
        // }
      } else {
        // if (_.size(this.loglist)) {
        //   this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        //     dtInstance.destroy();
        //   });
        // }
        this.errorValue = true;
        this.loglist = [];
      }
    });
  }

  messagePopUpTimeoutToogle() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp').attr('class');
      if (popUpClass == 'modal fade show') {
        $('#messagePopUp').modal('toggle');
      }
    }, 3000);
  }

  setDate(date) {
    if (date != '' && date != null) {
      return date.month + '-' + date.day + '-' + date.year;
    }
    return null;
  }

  
  maskEmail(email: string): string {
    if(email){
      const [username, domain] = email.split('@');
      return username && domain ? `${username.slice(0, 3)}******@${domain}` : '';
    }
  }

  ngAfterViewInit() {
    // Subscribe to sidebar toggle events
    this.sidebarSubscription = this.layoutService.sidebarToggled$.subscribe(() => {
      // Adjust table columns when sidebar toggles
      setTimeout(() => {
        this.adjustTableColumns();
      }, 350); // Wait for sidebar animation to complete
    });

    // Listen for window resize events
    this.resizeListener = () => {
      this.adjustTableColumns();
    };
    window.addEventListener('resize', this.resizeListener);
  }

  ngOnDestroy() {
    // Unsubscribe from sidebar toggle events
    if (this.sidebarSubscription) {
      this.sidebarSubscription.unsubscribe();
    }

    // Remove resize listener
    if (this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener);
    }
  }

  adjustTableColumns() {
    const table = $('#logtable');
    if (table.length) {
      const dataTable = table.DataTable();
      if (dataTable) {
        // Use DataTables built-in column adjustment
        dataTable.columns.adjust();
        
        // Additional sync after DataTables has adjusted
        setTimeout(() => {
          // Get the actual body table (the one in scrollBody)
          const bodyTable = $('#logtable_wrapper .dataTables_scrollBody table');
          const headerTable = $('#logtable_wrapper .dataTables_scrollHeadInner table');
          
          if (bodyTable.length && headerTable.length) {
            // Get all body cells from first row to measure widths
            const firstBodyRow = bodyTable.find('tbody tr:first-child');
            const headerCols = headerTable.find('thead th');
            
            if (firstBodyRow.length > 0 && headerCols.length > 0) {
              // Measure each column from body and apply to header
              firstBodyRow.find('td').each(function(index) {
                const $bodyCell = $(this);
                const $headerCell = headerCols.eq(index);
                
                if ($headerCell.length) {
                  // Get computed width including padding and borders
                  const bodyWidth = $bodyCell[0].getBoundingClientRect().width;
                  
                  if (bodyWidth > 0) {
                    // Apply width to header cell
                    $headerCell.css({
                      'width': bodyWidth + 'px',
                      'min-width': bodyWidth + 'px',
                      'max-width': bodyWidth + 'px',
                      'box-sizing': 'border-box'
                    });
                    
                    // Apply to all body cells in this column
                    bodyTable.find('tbody tr').each(function() {
                      const $cell = $(this).find('td').eq(index);
                      if ($cell.length) {
                        $cell.css({
                          'width': bodyWidth + 'px',
                          'min-width': bodyWidth + 'px',
                          'max-width': bodyWidth + 'px',
                          'box-sizing': 'border-box'
                        });
                      }
                    });
                  }
                }
              });
              
              // Sync colgroup if exists
              const bodyColgroup = bodyTable.find('colgroup');
              const headerColgroup = headerTable.find('colgroup');
              
              if (bodyColgroup.length && headerColgroup.length) {
                bodyColgroup.find('col').each(function(index) {
                  const $bodyCol = $(this);
                  const $headerCol = headerColgroup.find('col').eq(index);
                  if ($headerCol.length) {
                    const width = $bodyCol.width();
                    if (width > 0) {
                      $headerCol.css('width', width + 'px');
                    }
                  }
                });
              }
            }
          }
        }, 200);
      }
    }
  }
}
